import React from "react";
import { Col, Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as r from "routes";

const MainPageMobileCards = () => {
  const history = useHistory();

  return (
    <>
      <Col md="auto">
        <Card
          role="button"
          onClick={() => {
            history.push(r.DASHBOARD_ACCESS_CONTROL);
          }}
        >
          <Card.Body>
            <Card.Title>Access Control</Card.Title>
            <FontAwesomeIcon
              style={{ fontSize: "5vh" }}
              icon={["fal", "users"]}
            />
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default MainPageMobileCards;
